import React from 'react';
import { motion } from 'framer-motion';
import { Mic, Building2, Briefcase, ArrowRight } from 'lucide-react';
const roles = [{
  icon: <Mic className="w-6 h-6" data-id="element-504" />,
  title: 'For Artists & Bands',
  description: 'Plan routes, find venues, send outreach, lock lineups, and get paid.'
}, {
  icon: <Building2 className="w-6 h-6" data-id="element-505" />,
  title: 'For Venues & Promoters',
  description: 'Fill open dates, discover artists, compare options, send offers, and manage programming.'
}, {
  icon: <Briefcase className="w-6 h-6" data-id="element-506" />,
  title: 'For Agents & Managers',
  description: 'Run your roster, move deals faster, automate contracts and payments, and keep every booking on track.'
}];
export function RolePaths() {
  return <section className="py-24 bg-surface/10 border-y border-border relative" data-id="element-507">
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-508">
        <div className="text-center mb-16" data-id="element-509">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-510">
            One platform. Three native workflows.
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-511">
          {roles.map((role, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40,
          scale: 0.95,
          filter: 'blur(10px)'
        }} whileInView={{
          opacity: 1,
          y: 0,
          scale: 1,
          filter: 'blur(0px)'
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6,
          type: 'spring',
          bounce: 0.3
        }} className="group relative rounded-xl p-[1px] overflow-hidden cursor-pointer" data-id="element-512">
              {/* Animated Border Glow on Hover */}
              <div className="absolute inset-[-100%] bg-[conic-gradient(from_90deg_at_50%_50%,#00000000_50%,#F59E0B_100%)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{
            animation: 'rotate-gradient 4s linear infinite'
          }} data-id="element-513"></div>

              <div className="relative h-full bg-surface border border-border group-hover:border-transparent rounded-xl p-8 transition-colors flex flex-col z-10" data-id="element-514">
                {/* Sliding Top Line */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary/0 via-primary to-primary/0 -translate-x-full group-hover:translate-x-0 transition-transform duration-700 ease-out" data-id="element-515"></div>

                <div className="w-12 h-12 rounded-lg bg-background border border-border flex items-center justify-center mb-6 text-textMuted group-hover:text-primary group-hover:shadow-[0_0_15px_rgba(245,158,11,0.3)] transition-all duration-300" data-id="element-516">
                  {role.icon}
                </div>

                <h3 className="text-xl font-semibold mb-3 group-hover:text-white transition-colors" data-id="element-517">
                  {role.title}
                </h3>
                <p className="text-textMuted leading-relaxed mb-8 flex-1" data-id="element-518">
                  {role.description}
                </p>

                <div className="flex items-center gap-2 text-sm font-medium text-primary opacity-80 group-hover:opacity-100 transition-opacity mt-auto" data-id="element-519">
                  Learn more{' '}
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-520" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}